import { useContext, useSyncExternalStore } from 'react';

import { isNotDefined } from '@hsp/utilities';

import { SaveContext } from 'pages/audience/shared/save/context/save.context';
import { ISaveContext } from 'types/pages/audience-builder/shared/save/context';

export const useSaveStoreSelector = <SelectorOutput>(selector: (store: ISaveContext) => SelectorOutput) => {
  const store = useContext(SaveContext);

  if (isNotDefined(store)) {
    throw new Error('Store not found');
  }

  return useSyncExternalStore(store.subscribe, () => selector(store.get()));
};
